import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetReactivationPrefillData = gql`
  query GetReactivationPrefillData {
    getReactivationPrefillData {
      ... on ReactivationPrefillSuccess {
        address {
          addressLine1
          addressLine2
          city
          state
          zip
          country
          externalId
        }
        name {
          first
          last
          full
          initials
        }
        occupation
        registrationInfoId
        dateOfBirth
        citizenship
      }
      ... on ReactivationPrefillError {
        ...error
      }
      __typename
    }
  }
  ${error}
`;

export default GetReactivationPrefillData;
